<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="5"
        lg="4"
      >
        <fila-info-panel
          :filas="filas"
          :acesso-put="acessoPut"
          :acesso-disable="acessoDisable"
          @refetch-data="getFilas"
        />
      </v-col>

      <v-col
        cols="12"
        md="7"
        lg="8"
      >
        <v-tabs
          v-model="activeTab"
          show-arrows
          grow
          class="user-tabs"
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.icon"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>
            <span>{{ tab.title }}</span>
          </v-tab>

          <v-tab :to="{ name: 'filas' }">
            <v-icon color="error">
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          id="user-tabs-content"
          v-model="activeTab"
          class="mt-5 pa-1"
        >
          <v-tab-item>
            <fila-tab-tipo-solicitacao />
          </v-tab-item>

          <v-tab-item>
            <fila-tab-status />
          </v-tab-item>

          <v-tab-item>
            <fila-tab-equipes />
          </v-tab-item>

          <v-tab-item>
            <fila-tab-canais
              :loading="loading"
              :items="canais"
              :headers="headers"
              @refetch-data="getCanaisAssociados"
            />
          </v-tab-item>

          <v-tab-item>
            <fila-tab-formularios />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mapState } from 'pinia'
import { mdiBookmarkOutline, mdiAccountMultiple, mdiInformationOutline, mdiMessageText, mdiCloseCircleOutline, mdiFileMultipleOutline } from '@mdi/js'
import router from '@/router'
import FilaInfoPanel from '@/views/fila/FilaInfoPanel.vue'
import FilaTabCanais from '@/views/fila/tab-canais/FilaTabCanais.vue'
import FilaTabStatus from '@/views/fila/tab-status/FilaTabStatus.vue'
import FilaTabEquipes from '@/views/fila/tab-equipes/FilaTabEquipes.vue'
import FilaTabTipoSolicitacao from '@/views/fila/tab-tipo-solicitacao/FilaTabTipoSolicitacao.vue'
import FilaTabFormularios from '@/views/fila/tab-formularios/FilaTabFormularios.vue'
import FilaService from '@/services/modules/FilaService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    FilaInfoPanel,
    FilaTabCanais,
    FilaTabTipoSolicitacao,
    FilaTabStatus,
    FilaTabEquipes,
    FilaTabFormularios,
  },

  data() {
    return {
      filas: {},
      canais: [],
      loading: false,
      headers: [
        { text: 'NOME', value: 'nome' },
        { text: 'Tipo Canal', value: 'canalTipoNome' },
        { text: 'STATUS', value: 'status' },
        {
          text: 'OPÇÔES',
          value: 'actions',
          align: 'center',
        },
      ],
      idPut: 2002,
      acessoPut: true,
      idDisable: 2008,
      acessoDisable: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    this.getFilas()
    this.getCanaisAssociados()
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPut)) {
        this.acessoPut = false
      }
      if (!this.funcionalidades.includes(this.idDisable)) {
        this.acessoDisable = false
      }
    },
    async getFilas() {
      this.filas = await FilaService.getById(router.currentRoute.params.id)
    },
    async getCanaisAssociados() {
      this.loading = true

      this.canais = await FilaService.getCanais(router.currentRoute.params.id)

      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
  },

  setup() {
    const activeTab = ref(0)
    const tabs = [
      { icon: mdiBookmarkOutline, title: 'Tipos de Solicitação' },
      { icon: mdiInformationOutline, title: 'Status' },
      { icon: mdiAccountMultiple, title: 'Equipes' },
      { icon: mdiMessageText, title: 'Canais' },
      { icon: mdiFileMultipleOutline, title: 'Formulários' },
    ]

    return {
      activeTab,
      tabs,
      icons: {
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
